import { render, staticRenderFns } from "./placeholder_note.vue?vue&type=template&id=6e86a543&"
import script from "./placeholder_note.vue?vue&type=script&lang=js&"
export * from "./placeholder_note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "placeholder_note.vue"
export default component.exports